import session from '/@shared/session'
import { handleRouteError } from '/@shared/utils'

export default {
  render: () => null,
  mounted() {
    // TODO:: after migrating to sanctum this component no longer authenticates. Rename in the future
    const project = this.$route.query.project
    const grid = this.$route.query.grid

    if (!project || !grid) {
      console.warn('Authenticate route called without required parameters.')

      if (IS_DEPLOYED) {
        return window.location.replace('/')
      }
    }

    session.set('project', decodeURIComponent(this.$route.query.project))
    session.set('grid', decodeURIComponent(this.$route.query.grid))

    const name = IS_DEPLOYED ? 'front' : 'admin'

    this.$router.push({ name }).catch((error) => handleRouteError(error))
  },
}
